import type { SelectionWizardState } from "../../../models/eplex/Selection";
import { resolveTermLimit } from "./gsTermLimit";
import { DELIVERY_TERM_ANY } from "./smartFiltersStorage";

/**
 * Локальный черновик мастера настроек «Подбора» — состояние wizard'а до запуска.
 *
 * ВАЖНО: это НЕ то же самое, что «черновик» закупки в Zakooper (purchase.state=1
 * — уже созданная на бэке сущность). Здесь — чисто клиентский снимок ещё не
 * отправленных настроек, чтобы пользователь не потерял ввод при случайном выходе.
 * Ключ и сущность отдельные, чтобы не смешивать с серверными драфтами.
 */
const DRAFT_KEY = "selection.wizard.draft.v1";

export function saveSelectionDraft(state: SelectionWizardState): void {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify({ ...state, deliveryTermVersion: 1 }));
  } catch (error) {
    console.error("selection draft: cannot save", error);
  }
}

export function loadSelectionDraft(): SelectionWizardState | null {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    const state = JSON.parse(raw) as SelectionWizardState & { deliveryTermVersion?: number };
    if (state.goal === "other" && state.deliveryTermVersion !== 1) {
      state.strategy.maxTime = resolveTermLimit(state.strategy.maxTime) ?? DELIVERY_TERM_ANY;
    }
    return state;
  } catch (error) {
    console.error("selection draft: cannot load", error);
    return null;
  }
}

export function clearSelectionDraft(): void {
  try {
    localStorage.removeItem(DRAFT_KEY);
  } catch (error) {
    console.error("selection draft: cannot clear", error);
  }
}
